import * as actions from "@/AppRedux/actions/admin/rateDetailConfig/rateDetailConfigType"

export const rateDetailsListRequest = (): actions.RateDetailsListRequest => ({
  type: actions.RATE_DETAILS_LIST_REQUEST,
})

export const setRateDetailsListSuccess = (
  payload: actions.RateDetailsListResponse,
): actions.RateDetailsListSuccess => ({
  type: actions.RATE_DETAILS_LIST_SUCCESS,
  payload,
})

export const setRateDetailsListFailure = (message: string): actions.RateDetailsListFailed => ({
  type: actions.RATE_DETAILS_LIST_FAILED,
  payload: message,
})

export const rateDetailsGetRequest = (
  rateCode: string,
): actions.RateDetailsGetRequest => ({
  type: actions.RATE_DETAILS_GET_REQUEST,
  payload: { rateCode },
})

export const setRateDetailsGetSuccess = (
  payload: actions.RateData,
): actions.RateDetailsGetSuccess => ({
  type: actions.RATE_DETAILS_GET_SUCCESS,
  payload,
})

export const setRateDetailsGetFailure = (message: string): actions.RateDetailsGetFailed => ({
  type: actions.RATE_DETAILS_GET_FAILED,
  payload: message,
})

export const rateDetailsUpdateRequest = (
  rateData: actions.RateData,
): actions.RateDetailsUpdateRequest => ({
  type: actions.RATE_DETAILS_UPDATE_REQUEST,
  payload: rateData,
})

export const setRateDetailsUpdateSuccess = (): actions.RateDetailsUpdateSuccess => ({
  type: actions.RATE_DETAILS_UPDATE_SUCCESS
})

export const setRateDetailsUpdateFailure = (message: string): actions.RateDetailsUpdateFailed => ({
  type: actions.RATE_DETAILS_UPDATE_FAILED,
  payload: message,
})

export const rateDetailsUpdateSortOrderRequest = (
  items: actions.SortOrderItem[],
): actions.RateDetailsUpdateSortOrderRequest => ({
  type: actions.RATE_DETAILS_UPDATE_SORT_ORDER_REQUEST,
  payload: items,
})

export const setRateDetailsUpdateSortOrderSuccess = (): actions.RateDetailsUpdateSortOrderSuccess => ({
  type: actions.RATE_DETAILS_UPDATE_SORT_ORDER_SUCCESS,
})

export const setRateDetailsUpdateSortOrderFailure = (message: string): actions.RateDetailsUpdateSortOrderFailed => ({
  type: actions.RATE_DETAILS_UPDATE_SORT_ORDER_FAILED,
  payload: message,
})

export const clearRateDetailsProcess = (): actions.RateDetailsProcessClear => ({
  type: actions.RATE_DETAILS_PROCESS_CLEAR,
})
